import { useContext, useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router";
import { UserContext } from "../../Contexts/UserContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import Constants from "../../Constants";

export const useCFSExportRequest = ({filterData, url}) => {
    
    console.log('useCFSExportRequest called with:', {filterData, url});
    
    const { groupId, monthPickerValue, refineSearchFilters, setIocPayload, accessControls } = useContext(PeFilterContext);
    const { currency, globalSearchResult } = useContext(TableDataContext);
    const { logout, getToken } = useContext(UserContext);
    const location = useLocation();
    const [isExporting, setisExporting] = useState(false);
    const [requestBodyForExport, setRequestBodyForExport] = useState(
        {
            "profile_columns": ["Result Type"],
            "company_id": [],
            "date_range": {
                "from_date": monthPickerValue?.[0] || null,
                "to_date": monthPickerValue?.[1] || null
            },
            fy_year_count: null,
            financial_columns: [],
        }
    );
    const isFromGlobalSearch = ()=> refineSearchFilters[location.pathname]?.globalSearch?.length > 0 ? true : false
    const isMultiCompanySearch = ()=> refineSearchFilters[location.pathname]?.multiCompanySearch?.length > 0 ? true : false
    const isEmptyObject = (object) => Object.values(object).every(x => x == null || x === '' || x === undefined);

    const getRefineFilters = () => {

        //Charge based filters
        const selectedChargeAmt = refineSearchFilters[location.pathname]?.chargeAmount?.at(0)?.value;
        const selectedChargeDate = refineSearchFilters[location.pathname]?.chargeDate?.at(0)?.value;
        const selectedChargeCompanyName = Array.isArray(refineSearchFilters[location.pathname]?.chargeCompanies) 
            ? refineSearchFilters[location.pathname]?.chargeCompanies?.map(company => company.id) 
            : [];
        const selectedChargeHolderName = Array.isArray(refineSearchFilters[location.pathname]?.chargeHolders) 
            ? refineSearchFilters[location.pathname]?.chargeHolders?.map(holder => parseInt(holder.id, 10)) 
            : [];
        const chargeStateIds = Array.isArray(refineSearchFilters[location.pathname]?.chargeState) 
            ? refineSearchFilters[location.pathname]?.chargeState?.map(value => value.id) 
            : [];
        const chargeCityIds = Array.isArray(refineSearchFilters[location.pathname]?.chargeCity) 
            ? refineSearchFilters[location.pathname]?.chargeCity?.map(value => value.id) 
            : [];

        //growth based filters
        const IsCAGR = refineSearchFilters[location.pathname]?.growthCAGR?.at(0)?.value;
        const growthOperator = refineSearchFilters[location.pathname]?.growthOperator?.at(0)?.value;
        const yearMatchType = refineSearchFilters[location.pathname]?.growthYear?.at(0)?.value;
        const growthsTemp = Array.isArray(refineSearchFilters[location.pathname]?.growthPercentage) 
            ? refineSearchFilters[location.pathname]?.growthPercentage?.map(option => ({ key: `${option.value?.value}`, value: option.value?.moreThan })) 
            : [];
        const growthsYearsTemp = Array.isArray(refineSearchFilters[location.pathname]?.growthPercentage) 
            ? refineSearchFilters[location.pathname]?.growthPercentage?.map(option => ({ key: `${option.value?.value}_years`, value: option.value?.years })) 
            : [];
        //key value added dynamically
        const growths = growthsTemp?.reduce(
            (obj, item) => Object.assign(obj, { [item.key]: item.value }), {});
        const growthsYears = growthsYearsTemp?.reduce(
            (obj, item) => Object.assign(obj, { [item.key]: item.value }), {});

        //ratio based filters
        const ratioOperator = refineSearchFilters[location.pathname]?.ratioOperator?.at(0)?.value;
        const ratioyearMatchType = refineSearchFilters[location.pathname]?.ratioYear?.at(0)?.value;
        const ratioTemp = Array.isArray(refineSearchFilters[location.pathname]?.ratioPercentage)
            ? refineSearchFilters[location.pathname]?.ratioPercentage
                ?.map(option => option.value)
                ?.map(option => ({ [`${option.filterKey}_min`]: option.min, [`${option.filterKey}_max`]: option.max }))
            : [];

        const ratio = ratioTemp?.reduce(
            (obj, item) => Object.assign(obj, { ...item }), {});

        //financial based filters

        const financialOperator = refineSearchFilters[location.pathname]?.financialOperator?.at(0)?.value;
        const financialyearMatchType = refineSearchFilters[location.pathname]?.financialYear?.at(0)?.value;
        const financialCurrency = refineSearchFilters[location.pathname]?.financialCurrencyType?.at(0)?.value;
        const financialTemp = Array.isArray(refineSearchFilters[location.pathname]?.financialPercentage)
            ? refineSearchFilters[location.pathname]?.financialPercentage
                ?.map(option => option.value)
                ?.map(option => ({ [`${option.value}_min`]: option.min, [`${option.value}_max`]: option.max }))
            : [];

        const financial = financialTemp?.reduce(
            (obj, item) => Object.assign(obj, { ...item }), {});


        const growthReq = {
            "cagr": IsCAGR,
            "range_type": growthOperator,
            "year_match_type": yearMatchType,
            ...growths,
            ...growthsYears
        };

        const ratioReq = {
            "range_type": ratioOperator,
            "year_match_type": ratioyearMatchType,
            ...ratio,
        };

        const financialReq = {
            "range_type": financialOperator,
            "year_match_type": financialyearMatchType,
            "unit": financialCurrency,
            ...financial,
        };

        const payload = {
        company: refineSearchFilters[location.pathname]?.chargeCompanies || [],
        charge_holder_name: refineSearchFilters[location.pathname]?.chargeHolders || [],
        charge_date: selectedChargeDate,
        charge_amount: selectedChargeAmt,
        state: refineSearchFilters[location.pathname]?.chargeState || [],
        city: refineSearchFilters[location.pathname]?.chargeCity || []
        };

        setIocPayload(payload);

        const refineFilters = {
            from: isFromGlobalSearch() || isMultiCompanySearch() ? 'gs' : null,
            registered_names: Array.isArray(refineSearchFilters[location.pathname]?.multiCompanySearch) 
                ? refineSearchFilters[location.pathname]?.multiCompanySearch?.map(name => name.name) 
                : [],
            industry: Array.isArray(refineSearchFilters[location.pathname]?.industry) && refineSearchFilters[location.pathname]?.industry?.length > 0 
                ? refineSearchFilters[location.pathname]?.industry?.map(value => value.id) 
                : accessControls?.cfsindustries?.id,
            sector: Array.isArray(refineSearchFilters[location.pathname]?.sector) 
                ? refineSearchFilters[location.pathname]?.sector?.map(value => value.id) 
                : [],
            company_type: Array.isArray(refineSearchFilters[location.pathname]?.companyType) 
                ? refineSearchFilters[location.pathname]?.companyType?.map(type => type.id) 
                : [],
            transaction_status: Array.isArray(refineSearchFilters[location.pathname]?.transactionStatus) 
                ? refineSearchFilters[location.pathname]?.transactionStatus?.map(value => value.id) 
                : [],
            region: Array.isArray(refineSearchFilters[location.pathname]?.region) 
                ? refineSearchFilters[location.pathname]?.region?.map(region => region.id) 
                : [],
            state: Array.isArray(refineSearchFilters[location.pathname]?.state) 
                ? refineSearchFilters[location.pathname]?.state?.map(state => state.id) 
                : [],
            city: Array.isArray(refineSearchFilters[location.pathname]?.city) 
                ? refineSearchFilters[location.pathname]?.city?.map(city => city.id) 
                : [],
            year_founded: refineSearchFilters[location.pathname]?.yearFounded?.at(0) && {
            "from": refineSearchFilters[location.pathname]?.yearFounded[0]?.name,
            "to": refineSearchFilters[location.pathname]?.yearFounded[1]?.name
            },
            auditor_name: Array.isArray(refineSearchFilters[location.pathname]?.auditorName) 
                ? refineSearchFilters[location.pathname]?.auditorName?.map(audtior => audtior.name) 
                : [],
            result_type: refineSearchFilters[location.pathname]?.financialType?.at(0)?.id ?? "Both",
            financials: isEmptyObject(financialReq) ? null : financialReq,
            ratios: isEmptyObject(ratioReq) ? null : ratioReq,
            has_ioc : Array.isArray(refineSearchFilters[location.pathname]?.syndication) && refineSearchFilters[location.pathname]?.syndication?.length > 0
                ? refineSearchFilters[location.pathname]?.syndication?.map(value => value.value)[0] === '0' 
                    ? true 
                    : refineSearchFilters[location.pathname]?.syndication?.map(value => value.value)[0] === '1' 
                    ? false 
                    : undefined
                : undefined,
            charges: {
            company: selectedChargeCompanyName,
            charge_holder_name: selectedChargeHolderName,
            charge_date: selectedChargeDate,
            charge_amount: selectedChargeAmt,
            "state": chargeStateIds,
            "city": chargeCityIds,
            },
            growth: isEmptyObject(growthReq) ? null : growthReq,
            tag: {
                operator: refineSearchFilters[location.pathname]?.operator,
                data: Array.isArray(refineSearchFilters[location.pathname]?.tags) 
                    ? refineSearchFilters[location.pathname]?.tags?.map(tag => tag.name) 
                    : []
            },
            group:{  
                group_id: Array.isArray(groupId?.myList) && groupId?.myList?.length > 0
                    ? groupId?.myList?.map(id => id.group_id)?.toString() 
                    : null,
                sub_type_master_id: Array.isArray(groupId?.myList) && groupId?.myList?.length > 0 
                    ? Constants.subCategoryIds.cfs_id 
                    : null   
            }
        }
        console.log(refineFilters, "getRefineFilters");
        return refineFilters;
    } 

    const buildDealColumn = (filterOption, filterData) => {
        let data = [];
        const filterArray = filterData[filterOption?.filterKey];
        if (!Array.isArray(filterArray)) return data;
        
        filterArray?.filter(filter => filter.isChecked && parseInt(filter.id) !== 100)
            ?.forEach(filter => {
                if (filter.hasMore) {
                    const nestedData = buildDealColumn(filter, filterData);
                    data = [...data.concat(nestedData)];
                } else {
                    data = [...data.concat([filter])];
                }
            })
        if (data.length === 0) {
            filterData[filterOption?.filterKey]?.filter(filter => parseInt(filter.id) !== 100)
                ?.forEach(filter => {
                    if (filter.hasMore) {
                        const nestedData = buildDealColumn(filter, filterData);
                        data = [...data.concat(nestedData)];
                    } else {
                        data = [...data.concat([filter])];
                    }
                })
        }
        return data;
    }

    const getAllSelectedValues = useCallback(() => {
        console.log('getAllSelectedValues called with filterData:', filterData);
        const finalResult = {};
    
        // Function to modify column names based on currency
        const getValue = (v) => {
            const dynamic_columns = [
                'Revenue', 
                'EBITDA', 
                'EBDT', 
                'EBT', 
                'PAT', 
                'Opertnl Income', 
                'Interest',
                'Net Inc/Dec In Cash And Cash Equivalents',
                'Net CashFlow From Operating Activities',
                'Net Cash Used In Investing Activities',
                'Net Cash Used From Financing Activities'
            ];
            const postfix = currency === 'INR' ? ' (cr)' : ' (\$ M)';
            return dynamic_columns.includes(v) ? v + postfix : v;
        };
    
        // Check if filterData and filterData.initial exist
        if (!filterData?.initial) {
            console.log('filterData.initial not available, using defaults');
        } else {
            filterData.initial.forEach(filter => {
                if (!filter.isChecked) return;
                
                const selected = buildDealColumn(filter, filterData);
                
                const category = filterData?.category[filter?.category];
                
                const groupedColumns = selected.reduce((group, product, i) => {
                    // console.log(product, "produkct");
                    const { category } = product;
                    group[category] = group[category] ?? [];
                    if(product?.isChecked && product.value){
                        group[category].push(product);
                    }
                    return group;
                }, {});
                
                // Iterate over each key in the grouped columns
                for (const key in groupedColumns) {
                    if (groupedColumns.hasOwnProperty(key)) {
                        // Create or update the result for this category
                        // Apply getValue to modify column names
                        finalResult[key] = groupedColumns[key].map(item => getValue(item?.value));
                    }
                }
            });
        }
        const refine_filters = getRefineFilters();
        
        console.log(finalResult, "getAllSelectedValues result");
        setRequestBodyForExport(prev => ({
            ...prev,
            profile_columns: [...(finalResult?.profile_columns || []), "Result Type"],
            fy_year_count: finalResult?.fy_year_count?.[0],
            financial_columns: finalResult?.financial_columns ?? [],
            company_id: isFromGlobalSearch() ?  (globalSearchResult?.cfs_company || []) : [],
            "is_detailed": true,
            "currency_cd": currency,
            "display_in": currency === "INR" ? "C" : "M",
            "type": 5,
            refine_filters
        }));
        return finalResult;
    }, [filterData, currency, globalSearchResult]);

    useEffect(() => {
        if (filterData) {
            console.log('useEffect triggered, calling getAllSelectedValues');
            getAllSelectedValues();
        }
    }, [filterData, currency, globalSearchResult])

    // Separate useEffect for refine filters to avoid infinite loops
    useEffect(() => {
        if (refineSearchFilters[location.pathname] || groupId || accessControls) {
            // Update only the refine_filters part of the request body
            const refine_filters = getRefineFilters();
            setRequestBodyForExport(prev => ({
                ...prev,
                refine_filters,
                company_id: isFromGlobalSearch() ? (globalSearchResult?.cfs_company || []) : prev.company_id,
                "date_range": {
                    "from_date": monthPickerValue[0],
                    "to_date": monthPickerValue[1]
                }
            }));
        }
    }, [refineSearchFilters, location.pathname, accessControls, groupId, monthPickerValue, globalSearchResult])

    return { isExporting, requestBodyForExport}

};